module.exports = __webpack_public_path__ + "img/indomaret.a21b1536.svg";